var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 246 138",
    style: {
      enableBackground: "new 0 0 246 138"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EF2601;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Origin-Channel-Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-85.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_-col-",
    transform: "translate(85.000052, 12.000164)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "75.4,95 75.4,119.7 61.4,95 52.2,95 52.2,136.4 61.3,136.4 61.3,111.8 75.3,136.4  84.5,136.4 84.5,95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st0",
    points: "98.8,127.5 98.8,119.4 116.3,119.4 116.3,111 98.8,111 98.8,104.1 117.9,104.1  117.9,95.1 89.2,95.1 89.2,136.4 118.3,136.4 118.3,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "st0",
    points: "161.9,95 156.5,119.9 150.8,95 142.1,95 136.4,119.6 131.2,95 121.6,95 131.6,136.4  140.9,136.4 146.4,111.9 152,136.4 161.2,136.4 171.4,95  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M170.2,121.6l0,0.8c0,2.6,0.4,4.9,1.3,6.8c0.9,1.9,2.1,3.5,3.7,4.7c1.5,1.2,3.3,2.1,5.3,2.7 c1.9,0.6,4,0.8,6,0.8c2.5,0,4.8-0.3,6.8-1c2-0.7,3.7-1.6,5-2.8c1.4-1.2,2.4-2.7,3.1-4.3c0.7-1.7,1-3.5,1-5.4 c0-2.4-0.5-4.4-1.4-6c-0.9-1.5-2-2.8-3.3-3.7c-1.2-0.9-2.5-1.6-3.8-2c-1.2-0.4-2.2-0.7-2.9-0.8c0,0-5.5-1.5-5.5-1.5 c-1.4-0.4-2.4-0.8-3.2-1.2c-0.8-0.4-1.1-0.8-1.3-1c-0.2-0.3-0.3-0.8-0.3-1.4c0-0.7,0.1-1.2,0.4-1.6c0.3-0.5,0.6-0.8,1.1-1.1 c0.4-0.3,0.9-0.5,1.5-0.7c0.6-0.1,1.2-0.2,1.8-0.2c0.9,0,1.8,0.1,2.6,0.3c0.7,0.2,1.4,0.4,2,0.8c0.5,0.4,1,0.9,1.3,1.5 c0.3,0.7,0.5,1.5,0.6,2.6l0,0.8h9.2v-0.9c0-2.4-0.4-4.5-1.3-6.3c-0.8-1.7-2-3.2-3.5-4.3c-1.4-1.1-3.1-1.9-4.9-2.4 c-1.8-0.5-3.7-0.7-5.6-0.7c-1.7,0-3.4,0.3-5.1,0.8c-1.7,0.5-3.3,1.3-4.6,2.4c-1.4,1.1-2.5,2.4-3.3,4c-0.9,1.6-1.3,3.6-1.3,5.7 c0,2,0.3,3.6,1,5c0.7,1.4,1.6,2.5,2.7,3.5c1.1,0.9,2.3,1.6,3.7,2.2c1.3,0.6,2.7,1,4.1,1.4c1.3,0.4,2.6,0.8,3.9,1.1 c1.2,0.3,2.4,0.7,3.4,1.1c0.9,0.4,1.7,0.9,2.2,1.5c0.5,0.5,0.7,1.2,0.7,2c0,0.8-0.2,1.4-0.5,1.9c-0.4,0.6-0.9,1-1.5,1.3 c-0.6,0.3-1.3,0.6-2.1,0.7c-0.8,0.1-1.5,0.2-2.2,0.2c-1,0-2-0.1-2.9-0.4c-0.9-0.3-1.7-0.6-2.3-1.1c-0.6-0.5-1.1-1.2-1.5-2 c-0.4-0.8-0.6-1.8-0.6-3v-0.9H170.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "st0",
    points: "191.1,84.9 202.4,84.9 202.4,35.7 191.1,35.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "st0",
    points: "52.2,84.9 63.6,84.9 63.6,35.7 52.2,35.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M23.6,68.1h11.1c-2.3,4.8-7.1,8.4-12.5,7.6c-4.4-0.6-8.2-4-10-8c-3.8-8.5-0.1-20.8,9.8-22.4 c5.3-0.9,10.4,2.1,12.6,7.1h10.6c-1.3-7.9-6.9-14.6-15.1-16.8c-7.7-2-16.4-0.6-22.3,5C-3.4,51.3-2.6,73.3,10.5,82.1 c7.4,5,18.8,5.7,25.5-1v3.8h9.6V58.4c-4.3,0-21.8,0-21.8,0L23.6,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st0",
    d: "M87.1,76.8c-5.4,0-7.2-4.4-7.3-10c-0.1-5.5,2.1-9.9,7.2-9.9c5,0,7.1,4.4,7.1,9.9 S92.1,76.8,87.1,76.8 M87.2,47.8c-12,0-18.6,8.6-18.7,19c-0.1,10.5,6.7,19,18.7,19c11.8,0,18.3-8.4,18.3-19S99,47.8,87.2,47.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st1",
    points: "196.7,0 196.7,24.3 229.6,48.5 213.1,60.7 213.1,84.9 246,60.7 246,36.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st0",
    d: "M135.1,70.8c-0.9,4.4-4.7,7.6-9.5,5.3c-4-2-4.4-8.9-3.5-13c1.2-5.6,6.1-7.3,9.7-5.4 C135.7,59.6,136.1,66.6,135.1,70.8 M142.1,52.4c-5-5.5-14.5-6.4-20-1.1V35.7h-11.3v49.2h10.8v-2.5c3.2,3.2,8.8,4,13,3.1 c4.4-0.9,8-3.9,9.9-7.9C148.2,70.2,147.8,58.8,142.1,52.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st0",
    d: "M173.5,70.7c0,2.5-0.6,5.2-3,6.2c-3.4,1.4-6.3,0.4-7.1-0.4c-1-0.9-1.8-4.5,1.6-5.8 c1.4-0.5,2.8-0.7,4.2-0.9c1.5-0.2,2.9-0.4,4.3-0.9V70.7z M184.8,60c0-2.5-0.1-5-1.6-7.1c-4-5.6-12.8-5.6-18.9-4.8 c-6.6,0.9-12,4.9-12.2,12l0,0.8h11.3c0.1-1.9,0.6-3.8,2.4-4.4c1.8-0.6,5.4-0.8,6.9,0.7c0.6,0.6,0.9,2,0.8,3 c-0.1,0.9-1,1.3-1.8,1.7c-1.8,0.8-4.7,0.7-8.3,1.3c-4.9,0.8-10.2,2.2-11.8,7.8c-1.5,5.2,0.2,11,5.1,13.4 c5.2,2.5,13,1.8,17.5-1.7c0,0.1,0,2.3,0,2.3h10.6C184.8,84.9,184.8,68.3,184.8,60L184.8,60z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalNews);
export default __webpack_public_path__ + "static/media/global-news.6bf6008dad62628b21b20ac3d7b5c00f.svg";
export { ForwardRef as ReactComponent };